import format from 'date-fns/format'

export function unwrap (a, typeName, typeDict, dropLinks = false) {
  if (a && typeof a === 'object' && a.__value) {
    a = a.__value
  }
  if (isPrimitiveWrapper(a)) {
    a = a.valueOf()
  } else if (Array.isArray(a)) {
    a = a.map(item => unwrap(item, typeName, typeDict, dropLinks))
  } else if (a && typeof a === 'object') {
    if (a instanceof Date) {
      a = format(a, 'yyyy-MM-dd')
    } else { // recursively unwrap other objects, just in case
      const typeDef = typeDict[typeName]
      const propNames = Object.keys(a).filter(n => n !== '__keyObj')
      let newObj = {}
      for (const propName of propNames) {
        let propVal = a[propName]
        if (typeof propVal === 'function') {
          // skip
        } else if (propName === '_link') {
          if (dropLinks) {
            // skip
          } else {
            newObj[propName] = propVal
          }
        } else {
          const varDef = typeDef && typeDef.variables.find(v => v.name === propName)
          if (varDef && varDef.type === 'id' && typeDef.keyType === 'none') {
            // skip
          } else {
            if (varDef && varDef.type === 'selection') {
              if (propVal && typeof propVal === 'object') {
                if (dropLinks) {
                  if (propVal.__keyVal) {
                    propVal = propVal.__keyVal
                  } else if (propVal.__key && propVal.__keyObj) {
                    propVal = propVal.__keyObj[propVal.__key]
                  } else {
                    propVal = propVal[varDef.optionKeyName]
                  }
                }
              }
            }
            if (varDef && varDef.name === 'id$' && dropLinks && a._link) {
              propVal = a._link // when dropping links on knackly-native objects, _link (if present) should replace id$
            }
            const v = unwrap(propVal, varDef && varDef.typeName, typeDict, dropLinks)
            try {
              newObj[propName] = v
            } catch (e) {
              console.log(`in function unwrap: ${e}`)
            }
          }
        }
      }
      return newObj
    }
  }
  return a
}

function isPrimitiveWrapper (obj) {
  const value = (obj && obj.__value) || obj // look inside proxies
  const constructor = value && value.constructor
  return constructor && ['String', 'Number', 'Boolean'].includes(constructor.name)
}
